// Constantes para los roles de usuario
export const ROLES = {
  STUDENT: 1,
  ADMIN: 2,
  TEACHER: 3,
};

// Nombres de roles para mostrar en la UI
export const ROLE_NAMES = {
  [ROLES.STUDENT]: 'Estudiante',
  [ROLES.ADMIN]: 'Administrador',
  [ROLES.TEACHER]: 'Profesor',
};

// Función helper para obtener el nombre del rol
export const getRoleName = (roleId) => {
  return ROLE_NAMES[roleId] || 'Desconocido';
};

// Función helper para verificar si un roleId es válido
export const isValidRole = (roleId) => {
  return Object.values(ROLES).includes(roleId);
}; 